import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'

type Params = PaginatedParams & {
  unityId: string
}

const fetcher = (params: Params): PaginatedResponse<any> => {
  const { page = 1, limit = 10 } = params

  return axios.get('parameters/payment-methods', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadParamPaymentMethod(params: Params) {
  return useQuery(['loadParamPaymentMethod', params], () => fetcher(params), {
    keepPreviousData: true,
    enabled: !!params?.unityId,
    onError: () =>
      toast.error('Não foi possível carregar os tipos de pagamento', {
        toastId: 'loadParamPaymentMethod'
      })
  })
}
